module.exports = __webpack_public_path__ + "components/bike-park-header/static/background--4-b7a5658ca0b3ef262c03c6dcc66207f3.jpg";